import { createIsland } from 'preact-island'
import SalaryStatistics from '../components/salary-statistics/salary-statistics'

const islandName = 'salary-statistics'

const island = createIsland(SalaryStatistics)
island.render({
  selector: `[data-island="${islandName}"]`,
})
